import { Rule } from 'antd/lib/form';

export const CUSTOM_RULES: Record<string, Rule> = {
  personalData: {
    validator(_, value) {
      return value ? Promise.resolve() : Promise.reject();
    },
    message: 'Для продолжения требуется ваше согласие на обработку персональных данных',
  },
  loyaltyProgramAgreement: {
    validator(_, value) {
      return value ? Promise.resolve() : Promise.reject();
    },
    message: 'Для продолжения требуется ваше согласие с условиями бонусной программы',
  },
  offer: {
    validator(_, value) {
      return value ? Promise.resolve() : Promise.reject();
    },
    message: 'Для продолжения требуется ваше согласие с условиями Договора бронирования',
  },
} as const;
